export const ns = ['common'] as const;

export const defaultNS = ns[0];
